import React, { useState } from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Modal/Components/BaseModal/BaseModal';
import LaboratoryRequestCreate from './LaboratoryRequestCreate';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patientId: string;
	onRequestCreate: () => void;
	workplaceId: string;
}

const LaboratoryRequestCreateModal: React.FC<Props> = props => {
	const [modalSize, setModalSize] = useState<Size>(Size.MD);

	const handleClose = () => {
		setModalSize(Size.MD);
		props.onClose();
	};

	const handleOnRequirementSelect = () => {
		setModalSize(Size.FULLSCREEN);
	};

	const handleOnCreate = () => {
		setModalSize(Size.MD);
		props.onRequestCreate();
	};

	return (
		<BaseModal
			{...props}
			title='component.laboratoryRequestCreate.modalTitle'
			size={modalSize}
			onClose={handleClose}>
			<LaboratoryRequestCreate
				patientId={props.patientId}
				onRequestCreate={handleOnCreate}
				onRequestSelect={handleOnRequirementSelect}
				workplaceId={props.workplaceId}
			/>
		</BaseModal>
	);
};

export default LaboratoryRequestCreateModal;
